import React from 'react';
import {getDate} from './helper';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', display: 'flex', flexDirection: 'column', color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 18, borderBottom: '1px solid rgba(0,0,0,.3)', width: '100%', textAlign: 'center', paddingTop: 20, paddingBottom: 20
    },
    date: {
        position: 'absolute', top: 10, left: 10, fontSize: 14, color: '#14c0e9'
    },
    group: {
        position: 'absolute', 
        top: 10, 
        right: 10, 
        fontSize: 14, 
        color: '#3cde0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(255, 255, 255,.3)',
        borderRadius: '4px',
        padding: '5px 10px',
        fontWeight: 700
    },
    wrap: {
        padding: '0 20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5, 
        marginTop: 20
    },
    w50: {
        width: '50%'
    },
    block: {
        display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: 8
    },
    helper: {
        color: 'hsla(0,0%,100%,.5)',
        width: '100%',
        fontSize: '14px',
        fontFamily: 'PT-sans, sans-serif',
        paddingBottom: 4
    },
    description: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',    
    }
}))

const HistoryItem = ({item}) => {
    const classes = useStyles();
    const {event_date, amount, balance, group_name} = item;

    return (
        <div className={classes.root}>
            <span className={classes.date}>{getDate(event_date)}</span>
            <span className={classes.group}>{group_name}</span>
            <div className={classes.wrap}>
                <div className={classes.w50}>
                    <div className={classes.block}>
                        <span className={classes.helper}>Сумма пополнения:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(amount)} 
                        </span>
                    </div>
                </div>
                <div className={classes.w50}>
                    <div className={classes.block}>
                        <span className={classes.helper}>Баланс до:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(balance ? balance.toFixed(2) : balance)} 
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HistoryItem;